module.exports = __webpack_public_path__ + "img/file-zip.9056801a.svg";